import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { NumberInput } from '@iterable/deprecated_react_components';
import Dropdown from 'core/dropdown';

export const StyledCoreNumberInput = styled(NumberInput)`
  &&& {
    flex: 1 1 auto;
    margin-right: -${pxToRem(1)};
    width: 100%;
    &:first-child > input:not(:focus) {
      border-right: ${pxToRem(1)} solid transparent !important;
    }
    input {
      border-radius: 0 !important;
    }
  }
`;

export const StyledCoreDropdown = styled(Dropdown)`
  &&& {
    flex: 1 1 auto;
    max-width: ${pxToRem(130)};
    border-radius: 0 !important;
    margin-right: 0;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const DistancePickerContainer = styled.div`
  display: flex;
  [data-role='queryBuilder'][data-view-mode='true'] & {
    display: none !important;
  }
`;

export const ReadOnlyContainer = styled.div`
  color: #717171;
  [data-role='queryBuilder']:not([data-view-mode='true']) & {
    display: none !important;
  }
`;
